module.exports = __webpack_public_path__ + "public/img/发展历程OURDEVELOPMENT_EN.23abc7aa.png";